import React from 'react';
import { createRoot } from 'react-dom/client';

import OrderForm, { OrderFormContent } from '@/components/Forms/OrderForm';

interface InitOrderFormOptions {
  content: OrderFormContent;
  objectId?: string;
  source?: string;
  gaLabel?: string;
  onSuccess?: () => void;
}

const initOrderForm = ({
  content,
  objectId,
  source,
  gaLabel,
  onSuccess
}: InitOrderFormOptions): void => {
  const container = document.getElementById('order-form');

  if (!container) {
    return;
  }

  // eslint-disable-next-line no-underscore-dangle
  const { recaptchaSiteKey, recaptchaDisabled } = window.__config__;

  const root = createRoot(container);

  root.render(
    <OrderForm
      recaptchaSiteKey={recaptchaSiteKey}
      recaptchaDisabled={recaptchaDisabled}
      content={content}
      objectId={objectId}
      source={source}
      gaLabel={gaLabel}
      onSuccess={onSuccess}
    />
  );
};

export default initOrderForm;
